/* Quote/contact form wiring (shared by the quote-form section and the
   globo-form-styled snippet):
   - detects a successful Globo submission and swaps in the success state
   - personalizes the success heading with the submitted first name
   - generates the [ref] reference number
   - makes the upload dropzone clickable (its browse button is visually hidden)
*/
(() => {
  const init = () => {
    document.querySelectorAll('[data-quote-form]').forEach((root) => {
      if (root.dataset.qfInit) return;
      root.dataset.qfInit = '1';

      const app = root.querySelector('.quote-form__app');
      const success = root.querySelector('[data-quote-form-success]');
      if (!app) return;

      let armed = false;
      let shown = false;
      let submittedName = '';

      const capturedName = () => {
        // Find the text input whose Globo field label mentions "name"
        let input = app.querySelector('input[autocomplete="name"]');
        if (!input) {
          input = Array.from(app.querySelectorAll('input[type="text"]')).find((i) => {
            const label = i.closest('.globo-form-control')?.querySelector('.label-content');
            return label && /name/i.test(label.textContent);
          });
        }
        if (!input) input = app.querySelector('input[name="text-1"]');
        const raw = ((input && input.value) || '').trim();
        if (!raw) return '';
        const first = raw.split(/\s+/)[0];
        return first.charAt(0).toUpperCase() + first.slice(1);
      };

      app.addEventListener('click', (e) => {
        if (e.target.closest('button[type="submit"]')) {
          armed = true;
          submittedName = capturedName();
        }

        // Whole-dropzone click opens the file picker via the same input
        // Globo's own field label points at.
        const zone = e.target.closest('.gfb__dropzone');
        if (zone && !e.target.closest('button, input, a, .gfb__dropzone--preview--area')) {
          const picker = zone.querySelector('input[type="file"][id^="temp-for"]') || zone.querySelector('input[type="file"]');
          if (picker) picker.click();
        }
      });

      app.addEventListener('submit', () => {
        armed = true;
        submittedName = capturedName() || submittedName;
      }, true);

      // Hide the submit button's arrow while Globo is submitting
      // (button disabled or its built-in spinner visible)
      const syncSubmittingState = () => {
        const btn = app.querySelector('button[type="submit"]');
        if (!btn) return;
        // At rest Globo's spinner span is 0x0; it only gets dimensions while submitting
        const spinner = btn.querySelector('.spinner');
        const busy = btn.disabled
          || btn.classList.contains('loading')
          || (spinner && spinner.offsetWidth > 4);
        btn.classList.toggle('qf-submitting', !!busy);
      };

      const stateObserver = new MutationObserver(syncSubmittingState);
      stateObserver.observe(app, { subtree: true, attributes: true, childList: true, attributeFilter: ['style', 'class', 'disabled'] });
      syncSubmittingState();

      if (!success) return;

      const showSuccess = () => {
        if (shown) return;
        shown = true;

        const heading = success.querySelector('[data-quote-form-success-heading]');
        if (heading) {
          const template = heading.dataset.headingTemplate || heading.textContent;
          heading.textContent = submittedName
            ? template.replace(/\[name\]/gi, submittedName)
            : template.replace(/,?\s*\[name\]/gi, '');
        }

        const reference = success.querySelector('[data-quote-form-reference]');
        if (reference) {
          const template = reference.dataset.referenceTemplate || '';
          if (template.match(/\[ref\]/i)) {
            const ref = 'GF-' + String(Date.now()).slice(-5);
            reference.textContent = template.replace(/\[ref\]/gi, ref);
          }
        }

        root.classList.add('quote-form--submitted');
        success.hidden = false;
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const formHidden = () => {
        const form = app.querySelector('form.g-container');
        return form && form.offsetParent === null;
      };

      const successVisible = () => {
        const msg = app.querySelector('.globo-form .message.success');
        if (!msg) return false;
        const style = (msg.getAttribute('style') || '').replace(/\s/g, '');
        return style.includes('display:block') || style.includes('display:flex') || msg.offsetParent !== null;
      };

      const observer = new MutationObserver(() => {
        if (!armed || shown) return;
        if (formHidden() || successVisible()) showSuccess();
      });
      observer.observe(app, { subtree: true, attributes: true, childList: true, attributeFilter: ['style', 'class'] });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
